const AuthType = Object.freeze({
  AuthPassword: "AuthPassword",
  AuthCode: "AuthCode",
});

export default AuthType;
